export default __webpack_public_path__ + "static/media/down.ea600d71.svg";